var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Microsoft Logo",
    clipPath: "url(#clip0_8322_2943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.5 0H24.5V24H0.5V0Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.54346 1.04395H11.9782V11.4787H1.54346V1.04395Z",
    fill: "#F35325"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.0217 1.04395H23.4565V11.4787H13.0217V1.04395Z",
    fill: "#81BC06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.54346 12.5215H11.9782V22.9563H1.54346V12.5215Z",
    fill: "#05A6F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.0217 12.5215H23.4565V22.9563H13.0217V12.5215Z",
    fill: "#FFBA08"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8322_2943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/microsoft.7f8424e6fbb3d4752d25d956a1becced.svg";
export { ForwardRef as ReactComponent };